import { Box, Heading, Stack } from "@sembark-travel/ui/base"
import { Helmet } from "react-helmet-async"
import { ActivityLogs } from "../../../../ActivityLogs"
import { useParams } from "../../../../router-utils"

function TravelActivityActivities() {
	const { travelActivityId } = useParams("/travel-activities/:travelActivityId")
	return (
		<>
			<Helmet>
				<title>Travel Activity Activities</title>
			</Helmet>
			<Box padding="6" bgColor="default" roundedBottom="md">
				<Stack gap="2">
					<Heading as="h5">Activities</Heading>
					<ActivityLogs
						subjectType="travel_activities"
						subjectId={Number(travelActivityId)}
						hideTrackingInfo
					/>
				</Stack>
			</Box>
		</>
	)
}

export default TravelActivityActivities
